import React from "react";
import EasyEdit from "react-easy-edit";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Avatar, Button } from "@mui/material";
import { Phone, Email, LocationOn } from "@mui/icons-material";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import * as constants from "../../Components/constants";
import Link from "next/link";
import { blue } from "@mui/material/colors";
import { Print as PrintIcon } from "@mui/icons-material";

const baseURL = constants.BASE_URL;

const UserAboutView = () => {
  //ALL GENERAL INFO
  const [general, setGeneral] = useState([]);
  const [article, setArticle] = useState([]);
  const [book, setBook] = useState([]);
  const [education, setEducation] = useState([]);
  const [training, setTraining] = useState([]);
  const [workHis, setWorkHis] = useState([]);
  const [project, setProject] = useState([]);
  const [reSkill, setReSkill] = useState([]);
  const [workSkill, setWorkSkill] = useState([]);
  const [reWork, setReWork] = useState([]);

  const config = {
    mode: "cors",
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Token ${
        typeof window !== "undefined" ? localStorage.getItem("auth_token") : ""
      }`,
    },
  };

  const fetchData = () => {
    const data1 = `${baseURL}/user/user-general-info/${localStorage.getItem(
      "id"
    )}`;
    const data2 = `${baseURL}/user/user-research-article/${localStorage.getItem(
      "id"
    )}`;
    const data3 = `${baseURL}/user/user-book-publications/${localStorage.getItem(
      "id"
    )}`;
    const data4 = `${baseURL}/user/user-academic-degree/${localStorage.getItem(
      "id"
    )}`;
    const data5 = `${baseURL}/user/user-training/${localStorage.getItem("id")}`;
    const data6 = `${baseURL}/user/user-working-history/${localStorage.getItem(
      "id"
    )}`;
    const data7 = `${baseURL}/user/project-work/`;
    const data8 = `${baseURL}/user/user-research-skill/${localStorage.getItem(
      "id"
    )}`;
    const data9 = `${baseURL}/user/user-working-skills/${localStorage.getItem(
      "id"
    )}`;
    const data10 = `${baseURL}/user/user-research-work/${localStorage.getItem(
      "id"
    )}`;

    const getData1 = axios.get(data1, config);
    const getData2 = axios.get(data2, config);
    const getData3 = axios.get(data3, config);
    const getData4 = axios.get(data4, config);
    const getData5 = axios.get(data5, config);
    const getData6 = axios.get(data6, config);
    const getData7 = axios.get(data7, config);
    const getData8 = axios.get(data8, config);
    const getData9 = axios.get(data9, config);
    const getData10 = axios.get(data10, config);

    axios
      .all([
        getData1,
        getData2,
        getData3,
        getData4,
        getData5,
        getData6,
        getData7,
        getData8,
        getData9,
        getData10,
      ])
      .then(
        axios.spread((...allData) => {
          const allData0 = allData[0].data;
          const allData1 = allData[1].data;
          const allData2 = allData[2].data;
          const allData3 = allData[3].data;
          const allData4 = allData[4].data;
          const allData5 = allData[5].data;
          const allData6 = allData[6].data;
          const allData7 = allData[7].data;
          const allData8 = allData[8].data;
          const allData9 = allData[9].data;

          setGeneral(allData0[0]);
          setArticle(allData1);
          setBook(allData2);
          setEducation(allData3);
          setTraining(allData4);
          setWorkHis(allData5);
          setProject(allData6);
          setReSkill(allData7);
          setWorkSkill(allData8);
          setReWork(allData9);
        })
      );
  };

  useEffect(() => {
    fetchData();
  }, []);

  const save = (value) => {
    alert(value);
  };
  const cancel = () => {
    alert("Cancelled");
  };

  const handlePrint = () => {
    const printContents = document.getElementById("print-area").innerHTML;
    const originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  };

  return (
    <Container className="mt-5 pt-2">
      <Row id="print-area">
        <Col xs={12} md={3} style={{ backgroundColor: "#dae1f7" }}>
          <div className="d-flex align-items-center justify-content-center p-2">
            <Avatar
              alt="John Doe"
              src={general?.user?.profile_pic}
              sx={{ width: 150, height: 150 }}
            />
          </div>
          <h5 className="mt-3 text-break">{general?.user?.first_name}</h5>
          <h6 className="text-secondary"> {general?.user?.profession}</h6>
          <hr className="mb-4" />

          <ul className="list-unstyled">
            <li className="text-break">
              <Email color="info" /> {general?.user?.username}
            </li>
            <li className="py-2">
              <Phone color="info" />{" "}
              {general?.user_phone_no ? general?.user_phone_no : "Add Number"}
            </li>
            <li className="d-flex align-items-start">
              <LocationOn color="error" />{" "}
              <p>{general.user_permanent_address}</p>
            </li>
          </ul>
        </Col>
        <Col xs={12} md={9}>
          <h5>Summary</h5>

          <EasyEdit
            type="text"
            value={general.user_bio ? general.user_bio : "Add Summary"}
            onSave={save}
            onCancel={cancel}
            saveButtonLabel={<CheckCircleOutlineRoundedIcon color="success" />}
            cancelButtonLabel={<HighlightOffRoundedIcon color="error" />}
            attributes={{ name: "awesome-input", id: 1 }}
            instructions={
              <small className="text-muted">
                Adding more text to your summary won`t be saved after clicking
                save. This is for printing purposes only
              </small>
            }
            placeholder="Edit your summary"
          />

          <hr className="my-4" />
          <h5>Experience</h5>
          {workHis.map((work, idx) => (
            <div key={idx}>
              <h6>
                {work.designation}, {work.institute}
              </h6>
              <p>
                {moment(work.start_date).format("MMM YYYY")} -{" "}
                {moment(work.end_date).format("MMM YYYY")}
              </p>
              <ul>
                <li>{work.department}</li>
              </ul>
            </div>
          ))}

          <hr className="my-4" />
          <h5>Education</h5>
          {education.map((edu, idx) => (
            <div key={idx}>
              <h6>
                {edu.degree} in {edu.department}
              </h6>
              <span className="d-block">{edu.institutions}</span>
              <p>Graduated {moment(edu.end_date).format("ll")}</p>
            </div>
          ))}

          <hr className="my-4" />
          <h5>Training</h5>
          {training.map((tra, idx) => (
            <div key={idx}>
              <h6>
                {tra.designation}, {tra.institutions}
              </h6>
              <span className="d-block">{tra.description}</span>
              <p>Duration ({tra.duration} Months) </p>
            </div>
          ))}

          <hr className="my-4" />
          <h5 className="py-2">Publications</h5>
          <h6>Research Article</h6>
          {article.map((art, idx) => (
            <div key={idx}>
              <Link href={`${art.url_link}`}>{art.article_name}</Link>
              <span className="d-block">
                {art.publisher_name} (Publisher) et al. {art.authors_name}{" "}
                (Author)
              </span>
              <p>
                Article &#8226; {art.journals_name} {art.publication_year}
              </p>
            </div>
          ))}

          <h6>Book Chapters</h6>
          {book.map((bo, idx) => (
            <div key={idx}>
              <Link href={`${bo.publish_url}`}>{bo.book_name}</Link>
              <span className="d-block">
                {bo.publisher_name} et al. {bo.authors_name}
              </span>
              <p>Book &#8226; {moment(bo.publication_year).format("LL")} </p>
            </div>
          ))}

          <hr className="my-4" />
          <h5>Research Work</h5>
          {reWork.map((rew, idx) => (
            <div key={idx}>
              <span>{rew.institution}</span>
              <span className="d-block">
                {moment(rew.start_date).format("MMM YYYY")} -{" "}
                {moment(rew.end_date).format("MMM YYYY")}
              </span>

              <Link href={`${rew.involvement_research_work_info}`}>
                Involvement Research Work
              </Link>
            </div>
          ))}

          <hr className="my-4" />
          <h5>Skills</h5>
          <h6>Research Skill</h6>
          {reSkill.map((res, idx) => (
            <div key={idx}>
              <span>{res.area_of_research_interest}</span>
              <p>{res.key_research_skill}</p>
            </div>
          ))}

          <h6>Work Skill</h6>
          {workSkill.map((wok, idx) => (
            <div key={idx}>
              <span>{wok.area_of_interest}</span>
              <p>{wok.career_object_plan}</p>
              <p>{wok.key_working_skill}</p>
            </div>
          ))}

          <hr className="my-4" />
          <h5>Project</h5>
          {project.map((pro, idx) => (
            <div key={idx}>
              <h6>{pro.title}</h6>
              <span className="d-block">{pro.description}</span>
            </div>
          ))}

          <hr className="my-4" />
          <h5>Personal Profile</h5>
          <Row className="pt-2">
            <Col sm={3}>
              <h6>Name :</h6>
            </Col>
            <Col sm={9}>{general?.user?.first_name}</Col>
          </Row>
          <Row>
            <Col sm={3} className="fw-bold">
              <h6> Father Name :</h6>
            </Col>
            <Col sm={9}>{general?.fathers_name}</Col>
          </Row>
          <Row>
            <Col sm={3} className="fw-bold">
              <h6> Mother Name :</h6>
            </Col>
            <Col sm={9}>{general?.mothers_name}</Col>
          </Row>
          <Row>
            <Col sm={3} className="fw-bold">
              <h6> Marital Status :</h6>
            </Col>
            <Col sm={9}>
              {general.marital_status ? general.marital_status : "N/A"}
            </Col>
          </Row>
          <Row>
            <Col sm={3} className="fw-bold">
              <h6> Religion :</h6>
            </Col>
            <Col sm={9}>{general?.religion}</Col>
          </Row>
          <Row>
            <Col sm={3} className="fw-bold">
              <h6> Gender :</h6>
            </Col>
            <Col sm={9}>{general?.user_gender}</Col>
          </Row>

          <Row>
            <Col sm={3} className="fw-bold">
              <h6> Blood Group :</h6>
            </Col>
            <Col sm={9}>{general?.blood_group}</Col>
          </Row>
          <Row>
            <Col sm={3} className="fw-bold">
              <h6> Birthdate :</h6>
            </Col>
            <Col sm={9}>{general?.user_birthdate}</Col>
          </Row>
          <Row>
            <Col sm={3} className="fw-bold">
              <h6> Nationality :</h6>
            </Col>
            <Col sm={9}>{general?.nationality}</Col>
          </Row>
          <Row>
            <Col sm={3} className="fw-bold">
              <h6> Native Language :</h6>
            </Col>
            <Col sm={9}>{general?.native_language}</Col>
          </Row>
          <Row>
            <Col sm={3} className="fw-bold">
              <h6> Permanent Address :</h6>
            </Col>
            <Col sm={9}>{general?.user_permanent_address}</Col>
          </Row>
          <Row>
            <Col sm={3} className="fw-bold">
              <h6> Present Address :</h6>
            </Col>
            <Col sm={9}>{general?.user_present_address}</Col>
          </Row>
        </Col>
      </Row>

      <div className="text-end py-4">
        <Button
          onClick={() => handlePrint()}
          variant="outlined"
          startIcon={<PrintIcon sx={{ fontSize: 24, color: blue[500] }} />}
          sx={{
            borderRadius: 30,
            borderColor: blue[500],
            bgcolor: "transparent",
            "&:hover": {
              bgcolor: blue[50],
            },
          }}
        >
          Print
        </Button>
      </div>
    </Container>
  );
};

export default UserAboutView;
